import axiosTokenInstance from "services/api/backoffice";
import {
    BACKOFFICE_STATUS,
    BACKOFFICE_STATUS_ERROR,
} from "_models/redux/types";

// Action function
export const getBackofficeStatus = () => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/callcenter/leads/backoffice-status`
        );

        const { data, status } = response || {};

        dispatch({
            type: BACKOFFICE_STATUS,
            payload: data || {},
            status: status || {},
            method: "get",
        });
    } catch (e) {
        dispatch({
            type: BACKOFFICE_STATUS_ERROR,
            payload: e || {},
        });
    }
};
